<template>
    <fieldset>
      <legend class="panel-title"><b-link v-b-toggle.collapse-2 role="button" >Business Unit</b-link></legend>
      <b-collapse id="collapse-2">
        <div v-for="(value, key) in processedTeam" class="input-list" :key="key">
        <label><input type="checkbox" v-bind:id="key" v-bind:value="key" v-model="checkedNames" v-on:change="getCheckboxeIds()" /> {{ key }} ({{ value }})</label>
        </div>
      </b-collapse>
    </fieldset>

</template>

<script>
import { EventBus } from '../event-bus.js';

export default {
    name: 'TeamBox',
    props: ['teamData'],
    data: function () {
        return {
            checkedNames: [],
            taxonomyTags: {},
            firstLoad: true
        }
    },
    computed: {
        processedTeam: function() {
            // console.log('processedTeam');
            return this.teamData;
        }
    },
    created() {
        // preselct check box if team is set in url
        if(this.$route.params.id){
            // console.log('created');
            // console.log(this.$route.params.id);

            this.checkedNames[0] = this.reverseConvertToSlug(this.$route.params.id);
            // this.$parent.convertToSlug(this.checkedNames[0]) = this.$route.params.id;
            // console.log(this.checkedNames[0]);
        }
        // this.checkedNames=true;
    },
    updated() {
        // console.log('updated');
        // console.log(this.firstLoad);

        if(this.$route.params.id && this.firstLoad) {
            this.getCheckboxeIds();
            // console.log(this.firstLoad);
            this.firstLoad=false
        }
    },
    methods: {
        getCheckboxeIds() {
            // checkedTeamIDstore = this.checkedNames;
            // console.log(this.$route.params.id);

            // console.log('post mounted');
            // console.log(this.checkedNames);
            EventBus.$emit('checkedTeamIDstore', this.checkedNames);

            // this.$parent.getFilteredJobs(checkedLocationIDstore, checkedTeamIDstore, checkedCommitmentIDstore);
        },
        uncheckBoxes(){
            //console.log("child");
            this.checkedNames = [];
            EventBus.$emit('checkedTeamIDstore', this.checkedNames);
            // checkedTeamIDstore = [];
        },
        uncheckBox(box){
            var index = this.checkedNames.indexOf(box);
            if (index > -1) {
                this.checkedNames.splice(index, 1);
            }
            EventBus.$emit('checkedTeamIDstore', this.checkedNames);
            // console.log(checkedLocationIDstore);
            // this.$parent.getFilteredJobs(checkedLocationIDstore, checkedTeamIDstore, checkedCommitmentIDstore);
        },
        reverseConvertToSlug(str){
            return str.replace(/(-|^)([^-]?)/g, function(_, prep, letter) {
            return (prep && ' ') + letter.toUpperCase();
            });
        }
    }
}
</script>